import { Users } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, DropDownData, convertToNumber, deleteData, encryptPassword, sanitizeInput } from "../CommonComponents/CustomHooks";
import { CommonApiData, initializeFilterData } from "../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBoxNew, FormButton, InputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const TrainMaster = () => {
    const { path } = useParams();
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const data = CommonApiData();
    const initialFormData = {
        trainNo: '',
        trainName: '',
        TrainID: '',
        originBranch: '',
        destinationBranch: '',
        departureTime: '',
        arrivalTime: '',
        active: true,
        sunday: true,
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: true,
    }

    const [formData, setFormData] = useState(initialFormData);
    const GetGroupName = DropDownData('GetGroupNameUserWise', data.loginUserGroupID,)
    const groupList = GetGroupName?.data?.dropDownData || [];

    const GetBranchMaster = async (CurrentPage = currentPageNo) => {
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${CurrentPage}`,
            ...sortConfig,
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/User/ShowTrainMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED' || res.Status === 'UNAUTHORIZED') {
            await NotificationSound(res.Status, res.Message, res?.focus, inputrefs);
        }
    }

    const handleClear = () => {
        setFormData({
            ...initialFormData,
            userGroupID: groupList?.length === 1 ? groupList[0].valuePart : ""
        });
        filterData.SearchText = '';
        inputrefs.current['txtVehicleTypeName'].focus()
        setIsEdit(false)
        GetBranchMaster();
    }

    const handleSubmit = async () => {
        // await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/User/InsertUpdateTrainMaster`, { ...formData, password: encryptPassword(formData.password) })
        //await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data?.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        // await dispatch(setSubLoading(true))
        await setIsEdit(true);
        let editData = await ApiCall(`/api/User/EditTrainMaster`, { TrainID: id })
        //await dispatch(setSubLoading(false))
        if (editData.status === 'SUCCESS') {
            await inputrefs.current[editData?.focus].focus();
            setFormData((pre) => ({
                ...pre, ...editData,
            }))
        } else {
            await NotificationSound(editData.status, editData.message, editData?.focus, inputrefs);
        }
    }

    const handleDelete = async (id) => {
        // await dispatch(setSubLoading(true))
        await deleteData(`/api/User/DeleteVehicleMaster`, { VendorVehicleID: id }, GetBranchMaster, handleClear, '', inputrefs)
        //await dispatch(setSubLoading(false))
    }

    const handleChange1 = (i, p) => {
        GetBranchMaster(p)
    };

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const toTitleCaseWithSpace = (str = "") =>
        str
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (c) => c.toUpperCase())
            .trim();

    useEffect(() => {
        document.title = `${toTitleCaseWithSpace(path)}`
        //inputrefs.current['txtVehicleTypeName'].focus()
    }, [])

    useEffect(() => {
        if (groupList.length === 1 && !formData.userGroupID) {
            setFormData(prev => ({
                ...prev,
                userGroupID: groupList[0].valuePart
            }));
        }
    }, [groupList]);

    useEffect(() => {
        GetBranchMaster();
    }, [sortConfig]);

    return (
        <>
            <div className='bg-secondary-50 shadow-lg rounded-md p-3'>
                <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-2">
                            <Users className="w-5 h-5 text-primary-600" />
                            <h2 className="text-xl font-semibold text-primary-600">Train Master</h2>
                        </div>
                    </div>

                    <div className="card-body grid grid-cols-1 md:grid-cols-4 gap-3">

                        {/* Train No */}
                        <InputBox
                            id="txtTrainNo"
                            label="Train No"
                            placeholder="Enter Train No"
                            value={formData.trainNo}
                            onChange={(e) =>
                                setFormData({ ...formData, trainNo: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtMobileNo'].focus()
                                }
                            }}
                        />

                        {/* Train Name */}
                        <InputBox
                            id="txtTrainName"
                            label="Train Name"
                            placeholder="Enter Train Name"
                            value={formData.trainName}
                            onChange={(e) =>
                                setFormData({ ...formData, trainName: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtMobileNo'].focus()
                                }
                            }}
                        />

                        {/* Origin Branch */}
                        <AutoCompleteBoxNew
                            id="txtOriginBranch"
                            label="Origin Branch"
                            placeholder="Select Origin Branch"
                            autocompleteType="GetBranch"
                            value={formData.originBranch}
                            onChange={(e, val) =>
                                setFormData({ ...formData, originBranch: val || "" })
                            }
                            required
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtDestinationBranch'].focus()
                                }
                            }}
                        />

                        {/* Destination Branch */}
                        <AutoCompleteBoxNew
                            id="txtDestinationBranch"
                            label="Destination Branch"
                            placeholder="Select Destination Branch"
                            autocompleteType="GetBranch"
                            value={formData.destinationBranch}
                            onChange={(e, val) =>
                                setFormData({ ...formData, destinationBranch: val || "" })
                            }
                            required
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtDepartureTime'].focus()
                                }
                            }}
                        />

                        {/* Departure Time */}
                        <InputBox
                            id="txtDepartureTime"
                            label="Departure Time"
                            type="time"
                            value={formData.departureTime}
                            onChange={(e) =>
                                setFormData({ ...formData, departureTime: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtMobileNo'].focus()
                                }
                            }}
                        />

                        {/* Arrival Time */}
                        <InputBox
                            id="txtArrivalTime"
                            label="Arrival Time"
                            type="time"
                            value={formData.arrivalTime}
                            onChange={(e) =>
                                setFormData({ ...formData, arrivalTime: e.target.value })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtMobileNo'].focus()
                                }
                            }}
                        />

                        {/* Sunday */}
                        <Switch
                            id="txtSunday"
                            label="Sunday"
                            checked={formData.sunday}
                            onChange={(e) =>
                                setFormData({ ...formData, sunday: e.target.checked })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtMonday'].focus()
                                }
                            }}
                        />

                        {/* Monday */}
                        <Switch
                            id="txtMonday"
                            label="Monday"
                            checked={formData.monday}
                            onChange={(e) =>
                                setFormData({ ...formData, monday: e.target.checked })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtTuesday'].focus()
                                }
                            }}
                        />

                        {/* Tuesday */}
                        <Switch
                            id="txtTuesday"
                            label="Tuesday"
                            checked={formData.tuesday}
                            onChange={(e) =>
                                setFormData({ ...formData, tuesday: e.target.checked })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtWednesday'].focus()
                                }
                            }}
                        />

                        {/* Wednesday */}
                        <Switch
                            id="txtWednesday"
                            label="Wednesday"
                            checked={formData.wednesday}
                            onChange={(e) =>
                                setFormData({ ...formData, wednesday: e.target.checked })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtThursday'].focus()
                                }
                            }}
                        />

                        {/* Thursday */}
                        <Switch
                            id="txtThursday"
                            label="Thursday"
                            checked={formData.thursday}
                            onChange={(e) =>
                                setFormData({ ...formData, thursday: e.target.checked })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtFriday'].focus()
                                }
                            }}
                        />

                        {/* Friday */}
                        <Switch
                            id="txtFriday"
                            label="Friday"
                            checked={formData.friday}
                            onChange={(e) =>
                                setFormData({ ...formData, friday: e.target.checked })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtSaturday'].focus()
                                }
                            }}
                        />

                        {/* Saturday */}
                        <Switch
                            id="txtSaturday"
                            label="Saturday"
                            checked={formData.saturday}
                            onChange={(e) =>
                                setFormData({ ...formData, saturday: e.target.checked })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['txtActive'].focus()
                                }
                            }}
                        />

                        {/* Active */}
                        <Switch
                            id="txtActive"
                            label="Active"
                            checked={formData.active}
                            onChange={(e) =>
                                setFormData({ ...formData, active: e.target.checked })
                            }
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    inputrefs.current['btnSub'].focus()
                                }
                            }}
                        />

                    </div>

                    <div className='card-body'>
                        <FormButton
                            id={'btnSub'}
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            handleExport={async () => {
                                // await dispatch(setSubLoading(true))
                                handleDownloadExcel(`/api/User/ShowTrainMaster`, filterData, 'Train Master')
                                //await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear}
                        />
                    </div>
                </div>

            <div className="mt-3">
                <Table
                    handleEdit={handleEditData}
                    handleDelete={handleDelete}
                    loading={isLoading}
                    PageName={'TrainMaster'}
                    handleFilter={() => {
                        GetBranchMaster()
                        setFilterData({
                            ...filterData,
                        })
                    }}
                    filterData={filterData}
                    tableData={tableData}
                    setFilterData={setFilterData}
                    currentPageNo={currentPageNo}
                    handleChange1={handleChange1}
                    sortConfig={sortConfig}
                    handleSorting={handleSorting}
                />
            </div>

        </>
    )
}
export default TrainMaster;